import process3Image from "assets/hm_service_image/Progesss complete.png";
import progesss_4 from "assets/hm_service_image/Progesss_4.png";
import progesss_full from "assets/hm_service_image/progesss_full.png";
import progesss_3 from "assets/hm_service_image/Progesss payment.png";

const IMAGES = {
  progesss_3: progesss_3,
  process_4: process3Image,
  process_5: progesss_full,
  progesss_4_paid: progesss_4,

  transWatchSeri10: require("../assets/hm_service_image/Watch/WatchSeries10.png"),

  watchUltra2: require("../assets/hm_service_image/Watch/WatchUltra2_c.png"),
  watchultra3: require("../assets/hm_service_image/Watch/W-ULTRA3.png"),
  watchultra4: require("../assets/hm_service_image/Watch/ultra4.png"),
  watchSE3: require("../assets/hm_service_image/Watch/watchSE3.png"),
  watch11: require("../assets/hm_service_image/Watch/watch-11.png"),
  watch12: require("../assets/hm_service_image/Watch/watch-12.png"),
  airpodspro3: require("assets/hm_service_image/Watch/airpodspro3.png"),
  airpods5: require("assets/hm_service_image/Watch/airpods5.png")
};

export default IMAGES;
